import { render, staticRenderFns } from "./vpd-login-panel.vue?vue&type=template&id=396ef93c"
import script from "./vpd-login-panel.vue?vue&type=script&lang=js"
export * from "./vpd-login-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports